// extracted by mini-css-extract-plugin
export var card = "_m4-0";
export var content = "_m4-2";
export var details = "_m4-3";
export var icon = "_m4-1";
export var iconBlue = "_m4-5";
export var iconBrand = "_m4-4";
export var iconGrayBlue = "_m4-6";
export var iconGreen = "_m4-7";
export var iconIndigo = "_m4-8";
export var iconOrange = "_m4-9";
export var iconPurple = "_m4-a";
export var iconRed = "_m4-b";
export var iconWarning = "_m4-c";